import { render, staticRenderFns } from "./BotaoPrincipal.vue?vue&type=template&id=6eac8d1a"
import script from "./BotaoPrincipal.vue?vue&type=script&lang=js"
export * from "./BotaoPrincipal.vue?vue&type=script&lang=js"
import style0 from "./BotaoPrincipal.vue?vue&type=style&index=0&id=6eac8d1a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports